import { render, staticRenderFns } from "./successRelate.vue?vue&type=template&id=13423fe4&scoped=true&"
import script from "./successRelate.vue?vue&type=script&lang=js&"
export * from "./successRelate.vue?vue&type=script&lang=js&"
import style0 from "./successRelate.vue?vue&type=style&index=0&id=13423fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13423fe4",
  null
  
)

export default component.exports